
import {
    Session,
    User,
    AuthSession
  } from '@supabase/supabase-js'

export interface UserState {

    user ?: User;
    session?: Session;
    authSession?: AuthSession;
}

export const initialUserState: UserState = {

    user: undefined,
    session: undefined,
    authSession: undefined

};
